import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IGameAssignmentContext,
	GameAssignmentContext,
} from '../../../../../gameAssignmentState/gameAssignmentContext';
import Button from 'components/Button/Button';
import breadcrumbs from 'images/breadcrumbs.svg';
import style from './ResetBtn.module.scss';

const ResetBtn: React.FC = () => {
	const { resetSelectedControls, selectedCategory, selectedDeveloper, searchString, isUnassignedGames } =
		useContext<IGameAssignmentContext>(GameAssignmentContext);

	return (
		<Button
			className={style.resetBtn}
			theme="secondary"
			onClick={resetSelectedControls}
			disabled={!selectedCategory && !selectedDeveloper && !searchString && !isUnassignedGames}
			icon={
				<svg className={style.icon}>
					<use xlinkHref={`${breadcrumbs}#resetIcon`} />
				</svg>
			}
			data-test="ResetBtn">
			<Text translationNameSpace="listing" translationKey="resetButton" asFragment={true} />
		</Button>
	);
};

export default ResetBtn;
